import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { BaseDropout, TrimesterAccMentorWithAccDetails } from '@interfaces';
import { MentorDropoutsGridPart } from '../../../../../../ui/widget/shared-grids/mentor-dropouts-grid/mentor-dropouts-grid.part';
import { DeliveryOverviewService } from '../../../delivery-overview.service';

export interface AccMentorDropout extends BaseDropout {
	accMentorId: number,
	accTeamId: number,
	volunteerId: number,
	personId: number,
	name: string,
	accId: number,
	accName: string,
	facilitatorName: string,
	dropoutReason: string,
}


@Component({
	selector: 'delivery-mentor-dropouts-view-part',
	standalone: true,
	imports: [MentorDropoutsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-dropouts-view.part.html',
})
export class DeliveryMentorDropoutsViewPart {

	private readonly util = inject(UtilityService);
	readonly pageService = inject(DeliveryOverviewService);

	public mentorDropouts = computed<TrimesterAccMentorWithAccDetails[]>(() => {
		const data = this.pageService.areaService.deliveryData();

		if (!data) return [];

		const accById = this.util.array.toMap(data.accelerators, a => a.accId);

		return data.allMentors.filter(v => !!v.dropout).map(v => {
			const acc = accById[v.accId]!;
			return {
				...v,
				accName: acc.name,
				facilitatorStaffId: acc.facilitatorStaffId,
			};
		});
	});
}